/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class BadgesDaoService implements Resetable {
  public abstract saveBadges(badges: any): Promise<void>;
  public abstract getBadges(): Promise<any>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
